import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-end gap-3" }
const _hoisted_2 = { class: "flex justify-center mb-3" }
const _hoisted_3 = { class: "flex justify-center items-center gap-3" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-next-orange" }
const _hoisted_8 = { class: "flex justify-end" }
const _hoisted_9 = { class: "flex justify-end pt-3" }
const _hoisted_10 = { class: "m-auto px-8 md:px-20" }
const _hoisted_11 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_12 = { class: "py-5 flex justify-between" }
const _hoisted_13 = { class: "grid grid-cols-4 gap-4 mb-3 items-center" }
const _hoisted_14 = { class: "flex flex-col col-span-2" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col col-span-2"
}
const _hoisted_16 = { class: "flex justify-end" }
const _hoisted_17 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.lista.loading
      }, null, 8, ["visible"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
        backdrop: true
      }, {
        header: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("p", { class: "font-bold text-xl mb-3" }, "Importa costi timesheet", -1)
        ])),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_FileUpload, {
                uploaded_files: _ctx.uploaded,
                "onUpdate:uploaded_files": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploaded) = $event)),
                accept: ".xlx,.xls,.xlsx"
              }, {
                default: _withCtx(({props, methods}) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_NextButton, {
                      variant: "outline-secondary",
                      onClick: methods.open,
                      class: "w-56 h-10 px-4 grow"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                        _createTextVNode(" Allega ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createElementVNode("div", _hoisted_4, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "py-2" }, "Esegui senza interrompere l'operazione in caso di errori", -1)),
                      _createVNode(_component_Checkbox, {
                        checkClass: "h-4 w-4",
                        checked: _ctx.skip_errors,
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.skip_errors = !_ctx.skip_errors))
                      }, null, 8, ["checked"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["uploaded_files"])
            ])
          ]),
          (_ctx.uploaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded, (f, idx) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "underline text-sm text-next-atp pt-3 cursor-pointer",
                    onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                    target: "_blank",
                    key: idx
                  }, [
                    _createElementVNode("span", null, _toDisplayString(f.name), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.record_importati >= 0)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 1,
                class: "mt-3 bg-next-bri"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Record importati: " + _toDisplayString(_ctx.record_importati), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.errors.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_Alert, { class: "mt-3 bg-next-orange" }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("Importazioni con errori")
                  ])),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (e) => {
                  return (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(e), 1))
                }), 256))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_NextButton, {
                variant: "outline-secondary",
                onClick: _ctx.close,
                disabled: _ctx.loading,
                class: "col-start-3 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Chiudi ")
                ])),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_NextButton, {
                variant: "primary",
                disabled: _ctx.loading,
                onClick: _ctx.importa,
                class: "py-2 px-4 w-full flex items-center justify-center ml-3"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_Spinner, { class: "w-4 h-4 mr-4" }, null, 512), [
                    [_vShow, _ctx.loading]
                  ]),
                  _cache[10] || (_cache[10] = _createTextVNode(" Importa "))
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "text-2xl font-bold" }, "Lista Utenti", -1)),
          _withDirectives(_createVNode(_component_NextButton, {
            onClick: _ctx.openModal,
            class: "py-1 px-3"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Importa costi timesheet ")
            ])),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.hasPermission('can_import_costi_timesheet')]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Field, {
              field_name: "Cerca",
              "onUpdate:modelValue": [
                _ctx.lista.debounceSearch,
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lista.search) = $event))
              ],
              modelValue: _ctx.lista.search,
              placeholder: "Cerca"
            }, null, 8, ["onUpdate:modelValue", "modelValue"])
          ]),
          (_ctx.hasPermission('delete users'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_Checkbox, {
                  for_id: "deleted",
                  checked: _ctx.show_deleted,
                  onChange: _ctx.onToggle,
                  checkClass: "w-5 h-5"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Mostra cancellati ")
                  ])),
                  _: 1
                }, 8, ["checked", "onChange"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Paginator, {
            class: "",
            pagination: _ctx.lista.paginate
          }, null, 8, ["pagination"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
            cols: _ctx.usersCols,
            "onUpdate:cols": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usersCols) = $event)),
            rows: _ctx.lista.rows,
            onOrderUpdate: _ctx.lista.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDateTime(c.created_at)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_4`,
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDateTime(c.deleted_at)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_5`,
                fn: _withCtx((context) => [
                  _createVNode(_component_router_link, {
                    to: {name:'DettaglioUtente', params:{id:context.context.row.id}},
                    class: "text-center inset-0 absolute flex items-center justify-center"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["to"])
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.lista.fetchNextPage,
          identifier: _ctx.lista.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[15] || (_cache[15] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri utenti.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}